module.exports = __webpack_public_path__ + "static/pod-gore-1-636bb37f0bcca2d99d3bfec59f149e03.jpg";